
(function ($) {

    $(document).ready(function () {

        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            var imgPos = scrollTop / 3 + 'px';
            var imgPosSlow = scrollTop / 12 + 'px';
            var imgPosCenter = scrollTop / 4 + 'px';
            var imgPosBottom = scrollTop / 6 + 'px';
            $('.is-style-parallax').find('img').css('transform', 'translateY(' + imgPos + ')');
            $('.is-style-center-parallax').find('img').css('transform', 'translateY(' + imgPosCenter + ')');
            // bottom-parallax
            $('.is-style-bottom-parallax').find('img').css('transform', 'translateY(-' + imgPosBottom + ')');

            $('.is-style-parallax-up').find('img').css('transform', 'translateY(-' + imgPos + ')');
            $('.is-style-parallax-content-up').css('transform', 'translateY(-' + imgPos + ')');
            $('.is-style-parallax-content-up-slow').css('transform', 'translateY(-' + imgPosSlow + ')');
        });

    });

})( jQuery );